import(/* webpackMode: "eager", webpackExports: ["AuthForgotPasswordFormComponent"] */ "/app/src/components/auth/auth-forgot-password-form.tsx");
